import { MapPin } from "lucide-react";
import { NEARBY } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { SITE } from "@/data/site";

const Card = ({ place }) => (
  <div className="group relative mx-2.5 h-64 w-52 shrink-0 overflow-hidden rounded-2xl sm:h-72 sm:w-60">
    <img
      src={place.image}
      alt={place.name}
      loading="lazy"
      onError={(e) => { e.currentTarget.src = SITE.heroImage; }}
      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/20 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-4">
      {place.distance && (
        <p className="mb-1 flex items-center gap-1.5 text-xs text-champagne"><MapPin className="h-3.5 w-3.5" /> {place.distance} away</p>
      )}
      <p className="font-display text-xl font-bold leading-tight text-ivory">{place.name}</p>
    </div>
  </div>
);

// Fast, live-feel auto-scrolling marquee of nearby attractions
export default function NearbyFastSlider({ dark = true, heading = true }) {
  const row = [...NEARBY, ...NEARBY];
  return (
    <section data-testid="nearby-slider" className={`overflow-hidden py-14 md:py-20 ${dark ? "bg-forest text-ivory" : "bg-ivory text-charcoal"}`}>
      {heading && (
        <div className="mx-auto mb-12 max-w-[1400px] px-5 md:px-10">
          <Reveal><p className={`mb-5 text-xs uppercase tracking-widest-2 md:text-sm ${dark ? "text-gold" : "text-brown"}`}>Around The Valley</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className={`font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-5xl md:text-6xl ${dark ? "text-ivory" : "text-forest"}`}>
              Nearby Attractions
            </h2>
          </Reveal>
        </div>
      )}

      <div className="relative">
        <div className={`pointer-events-none absolute inset-y-0 left-0 z-10 w-12 md:w-24 bg-gradient-to-r ${dark ? "from-forest" : "from-ivory"} to-transparent`} />
        <div className={`pointer-events-none absolute inset-y-0 right-0 z-10 w-12 md:w-24 bg-gradient-to-l ${dark ? "from-forest" : "from-ivory"} to-transparent`} />
        <div className="marquee-fast">
          {row.map((p, i) => (
            <Card key={i} place={p} />
          ))}
        </div>
      </div>
      <p className={`mt-8 text-center text-xs ${dark ? "text-ivory/50" : "text-charcoal/50"}`}>Distances are approximate by road from the resort</p>
    </section>
  );
}
